var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSharpOutlineSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0061 3.00523C9.72937 3.00533 8.47115 3.31077 7.33643 3.89605C6.20172 4.48133 5.22342 5.32948 4.48316 6.36974C3.7429 7.41 3.26214 8.61221 3.081 9.87606C2.89985 11.1399 3.02357 12.4288 3.44184 13.6351C3.86011 14.8414 4.56079 15.9302 5.48542 16.8106C6.41006 17.691 7.53184 18.3376 8.75718 18.6963C9.98251 19.0551 11.2759 19.1156 12.5293 18.8728C13.7828 18.63 14.96 18.091 15.9628 17.3007L20.6864 22.0031L22 20.5052L17.2948 15.9687C18.2255 14.7881 18.8049 13.3693 18.9669 11.8746C19.1289 10.38 18.8668 8.87 18.2106 7.51739C17.5544 6.16478 16.5307 5.02422 15.2566 4.22625C13.9825 3.42827 12.5095 3.00513 11.0061 3.00523ZM6.67662 6.68253C5.52836 7.83079 4.88328 9.38816 4.88328 11.012C4.88328 12.6359 5.52836 14.1933 6.67662 15.3416C7.82488 16.4898 9.38225 17.1349 11.0061 17.1349C12.63 17.1349 14.1874 16.4898 15.3357 15.3416C16.4839 14.1933 17.129 12.6359 17.129 11.012C17.129 9.38816 16.4839 7.83079 15.3357 6.68253C14.1874 5.53427 12.63 4.88918 11.0061 4.88918C9.38225 4.88918 7.82488 5.53427 6.67662 6.68253Z",
    fill: "#B9BDC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSharpOutlineSearch);
export default __webpack_public_path__ + "static/media/sharp--outline--search.6983b1405652bd42ced48539304bfd30.svg";
export { ForwardRef as ReactComponent };